import { useNavigate } from "react-router-dom";
import urls from "../../../config/urls.json";
import { useSession } from "../../../hooks/useSession";
import { ApiService as api } from "../../../services/ApiService";
import { useStates } from "../../../hooks/useStates";
import { isCf } from "../../../services/validators";
import { useEffect, useState } from "react";
import { useEditAppointment } from "../../../hooks/useEditAppointment";
import { useDynatrace } from "../../../hooks/useDynatrace";
import { isProd } from "../../../services/env";

export const useCodiceFiscalePage = () => {
    const navigate = useNavigate();
    const { read, update, batchUpdate, isCompassQuintoSite } = useSession();
    const { states, setCurrentState, isDatiUtenteReady, isCfFetchStart, isCfFetchError, isCfEditAppointment } = useStates();
    const { showModal, closeModal, setCodiceFiscale, codiceFiscale, codiceFiscaleError, askForEditAppointment } = useEditAppointment();

    const [fetchError, setFetchError] = useState(false);
    const [fetchErrorMessage, setFetchErrorMessage] = useState("");

    useEffect(() => {
        setCurrentState(states.LOAD_FILIALI_SLIDES_END);
        if(read("codiceFiscale") && read("codiceFiscale") != "") {
            onCfChange(read("codiceFiscale"));
        }
    }, []);

    const {} = useDynatrace();

    const setPrestitoPersonale = () => {
        update("prodotto", 1);
        navigate(urls.luogo.path);
    };

    const setPrestitoBusiness = () => {
        update("prodotto", 5);
        navigate(urls.prestitoBusiness.path);
    };
    const vaiLuogo = () => {
        navigate(urls.luogoC5.path);
    };
    const clink = () => {
        navigate(urls.clink.path);
    };

    const onCfChange = async (value) => {
        setCurrentState(states.BUSY);
        update("codiceFiscale", value);
        update("codiceFiscale_external", value);

        if (value.length < 16) return;

        if (!isCf(value)) {
            setCurrentState(states.FETCH_CF_ERROR);
            return;
        }

        setCurrentState(states.FETCH_CF_START);

        let cfResult = {};
        try {
            cfResult = await api.GetUserDataAndAppointmentByCf({
                CodiceFiscale: value,
            }, 3);
        } catch (error) {
            setFetchErrorMessage("C'è stato un errore con il codice fiscale inserito. <br />Per favore riprova.");
            setFetchError(true);
            setCurrentState(states.LOAD_FILIALI_SLIDES_END);
            return;
        }

        // let's see if he has an appointment already
        update("oppID", "");

        // WAF...
        if (!cfResult.hasOwnProperty("appointmentData")) {
            setFetchErrorMessage("C'è stato un errore con il codice fiscale inserito. <br />Per favore riprova.");
            setFetchError(true);
            setCurrentState(states.LOAD_FILIALI_SLIDES_END);
            return;
        }

        const utente = cfResult.datiCliente || {};
        update("tipoOccupazione", (utente.tipoOccupazione || ""))
        const oppID = cfResult.appointmentData && cfResult.appointmentData.appointmentId && cfResult.appointmentData.appointmentId != "" ? cfResult.appointmentData.appointmentId : null;
        if (null != oppID) {
            setCurrentState(states.FETCH_CF_EDIT_APPOINTMENT);
            askForEditAppointment();
            return;
        }

        update("ricontattoCf", cfResult.Ricontatto);

        
        const mergeableFields = {
            utenteRiconosciuto: null != utente.codiceFiscale,
        };
        mergeableFields["nome"] = utente.nome || "";
        mergeableFields["cognome"] = utente.cognome || "";
        mergeableFields["email"] = utente.email || "";
        mergeableFields["cellulare"] = utente.telefono || utente.cellulare || "";
        mergeableFields["cap_utente"] = utente.cap || "";
        if (cfResult.isAlreadyPP === true) {
            mergeableFields["prodotto"] = 1;
        }
        batchUpdate(mergeableFields);
        setCurrentState(states.FETCH_CF_END);
    };

    const next = async () => {
        if (true == read("ricontattoCf") && true == read("ricontattoLuogo")) {
            update("ricontatto", true);
            clink();
        } else if (read("prodotto") == 1) {
            //riconosciuto come PP
            if(isCompassQuintoSite()) {
                try {
                    const tokenEncodeRes = await api.TokenB2BEncode({
                        firstName: read("nome"),
                        lastName: read("cognome"),
                        email: read("email"),
                        mobilePhone: read("cellulare"),
                        fiscalCode: read("codiceFiscale"),
                    });
                    if(tokenEncodeRes) {
                        window.location.href = `${isProd() ? "https://compass.it" : "https://compass-col.int.compassonline.it"}/fa3?token=${tokenEncodeRes.token}&AppCode=FAC5&isB2B=true`;
                    }
                } catch (error) {
                    console.log(error);
                }
            }
            else {
                navigate(urls.luogo.path);
            }            
        } else {
            vaiLuogo();
        }
    };

    const getCfInputState = () => {
        return isCfFetchError() ? 4 : isCf(read("codiceFiscale")) ? 3 : 1;
    };

    return {
        read,
        update,
        onCfChange,
        next,
        vaiLuogo,
        clink,
        isDatiUtenteReady,
        isCfFetchStart,
        isCfFetchError,
        isCfEditAppointment,
        getCfInputState,
        fetchErrorMessage,
        fetchError,
        setFetchError,
        showModal,
        closeModal,
        setCodiceFiscale,
        codiceFiscale,
        codiceFiscaleError,
        askForEditAppointment,
        setPrestitoBusiness,
        setPrestitoPersonale,
    };
};
